var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMapPin = function SvgMapPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5 14.5774C3.14864 15.3941 2 16.5322 2 17.791C2 20.2763 6.47715 22.291 12 22.291C17.5228 22.291 22 20.2763 22 17.791C22 16.5322 20.8514 15.3941 19 14.5774M18 8.29102C18 12.3547 13.5 14.291 12 17.291C10.5 14.291 6 12.3547 6 8.29102C6 4.97731 8.68629 2.29102 12 2.29102C15.3137 2.29102 18 4.97731 18 8.29102ZM13 8.29102C13 8.8433 12.5523 9.29102 12 9.29102C11.4477 9.29102 11 8.8433 11 8.29102C11 7.73873 11.4477 7.29102 12 7.29102C12.5523 7.29102 13 7.73873 13 8.29102Z",
    stroke: "#959881",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMapPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map-pin.bd0fbebe5f5d7d4f0c733db065ab6a43.svg";